import { combineReducers } from 'redux';

import messages from './messages';

const initialState = {
    id: '',
    topic: '',
    user1: null,
    user2: null,
    moderator: null,
    messages: [],
    guestList: [],
    alert: '',
    currentScript: '',
    articleA: '',
    articleB: '',
    showLinks: false,
    endConversation: false,
    promptFeedback: false,
    voteDict: {},
    convoCode: '',
    helpScript: '',
    isFetchingScripts: false,
    isFetching: false,
    numUsers: 0
}

const meta = (state = initialState, action) => {
    console.log("META ACTION!!", action);
    switch (action.type) {
        case 'SET_CONVO_CODE':
            return Object.assign({}, state, {
                convoCode: action.convoCode
            });
        case 'START_FETCHING_MESSAGES':
            return Object.assign({}, state, {
                isFetching: true
            });
        case 'START_FETCHING_SCRIPTS':
            return Object.assign({}, state, {
                isFetchingScripts: true
            });
        case 'RECEIVED_SCRIPTS':
            return Object.assign({}, state, {
                isFetchingScripts: false
            });
        case 'ADD_SCRIPT':
            return Object.assign({}, state, {
                currentScript: action.script
            });
        case 'ADD_LINKS':
            return Object.assign({}, state, {
                articleA: action.articleA,
                articleB: action.articleB,
                showLinks: true
            });
        case 'SET_LINKS_FALSE':
            return Object.assign({}, state, {
                showLinks: false
            });
        case 'GENERATE_HELP_SCRIPT':
            return Object.assign({}, state, {
                helpScript: action.choice
            });
        case 'END_CONVERSATION':
            return Object.assign({}, state, {
                endConversation: action.endConversation
            });
        case 'PROMPT_FEEDBACK':
            return Object.assign({}, state, {
                promptFeedback: true
            });
        case 'RECEIVED_MESSAGES':
            return Object.assign({}, state, {
                isFetching: false
            });
        case 'SET_GUEST_LIST':
            return Object.assign({}, state, {
                guestList: action.guestList
            });
        case 'SET_ALERT':
            return Object.assign({}, state, {
                alert: action.alert
            });
        case 'UPDATE_ID':
            return Object.assign({}, state, {
                id: action.id
            });
        case 'UPDATE_TOPIC':
            return Object.assign({}, state, {
                topic: action.topic
            });
        case 'ADD_USER1':
            return Object.assign({}, state, {
                user1: action.user,
                numUsers: action.numUsers + 1
            });
        case 'ADD_USER2':
            return Object.assign({}, state, {
                user2: action.user,
                numUsers: action.numUsers + 1
            });
        case 'ADD_MODERATOR':
            return Object.assign({}, state, {
                moderator: action.user,
                numUsers: action.numUsers + 1
            });
        default:
            return state
    }
}

const convo = combineReducers({
    messages,
    meta
});

export default convo;



// WEBPACK FOOTER //
// ./src/reducers/convo.js